__turbopack_context__.v({
  "sidebarItem": "DNPdXG_sidebarItem",
  "sidebarList": "DNPdXG_sidebarList",
  "sidebarNav": "DNPdXG_sidebarNav",
  "subbieSubLine": "DNPdXG_subbieSubLine",
  "subbieUpgrade": "DNPdXG_subbieUpgrade",
});
